"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var image_1 = __importDefault(require("next/image"));
var apps_shared_1 = require("@l2p/apps-shared");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var styles_module_scss_2 = __importDefault(require("../styles.module.scss"));
var ListLanguages = function (_a) {
    var setOpenLang = _a.setOpenLang, currentLang = _a.currentLang, languages = _a.languages;
    var getPageWithNewLang = (0, apps_shared_1.usePageWithNewLang)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container }, languages.map(function (lang) {
        return lang.key !== currentLang ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.langWrapper, key: lang.key },
            react_1.default.createElement("a", { href: getPageWithNewLang(lang.key), className: styles_module_scss_2.default.lang, onClick: function () {
                    setOpenLang(false);
                }, key: lang.key },
                react_1.default.createElement(image_1.default, { src: "/img/langFlags/".concat(lang.key, ".svg"), alt: lang.title + ' flag', width: 28, height: 28 })))) : null;
    })));
};
exports.default = ListLanguages;
